import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ tokens }, { withPaddingBottom }, classes)=>({
        root: {
            overflow: 'hidden',
            paddingBottom: withPaddingBottom ? tokens.spacing['56'] : 0,
            [`& .${classes.endIcon}`]: {
                fontSize: tokens.typography.variant.overline.fontSize
            }
        }
    }));
export { useStyles };
